import { ippeCalculationMembersDataset } from '@/lib/member-views/datasets/ippeCalculationMembers.dataset';
import type { IppeCalculationMemberRow } from '@/lib/members/members.types';
import { MemberIdentityCell } from '../cells/MemberIdentityCell';
import { PriorityTagsCell } from '../cells/PriorityTagsCell';
import { MemberViewShell, type MemberViewShellProps } from '../MemberViewShell';

const cellOverrides: MemberViewShellProps<IppeCalculationMemberRow>['cellOverrides'] = {
  // The server returns no MDVIP ID for this view, so the cell shows the name alone.
  patient: (row) => <MemberIdentityCell firstName={row.firstName} lastName={row.lastName} mdvipId={row.mdvipId} />,
  priorityTags: (row) => <PriorityTagsCell tags={row.priorityTags} />,
};

/**
 * IPPE Calculation: the practice's members about to turn 65, with their suggested exam window.
 *
 * A function declaration for the same reason as `AllActiveMembersView`: the view registry and the
 * shell import each other, and a hoisted function survives that cycle where a `const` might not.
 */
export function IppeCalculationMembersView() {
  return <MemberViewShell dataset={ippeCalculationMembersDataset} cellOverrides={cellOverrides} />;
}
